import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import { NumericFormat as NumberFormat } from "react-number-format";
import {TIPO_ENVIO} from '../../../../_helpers';

/**
 * Items de una venta/compra, en el detalle expandible de la tabla.
 *
 * <p>Antes era una tabla angosta de 5-6 columnas: en mobile cada celda quedaba apretada
 * a unos pocos caracteres. Reusa las mismas cards de `.checkout__product-item` que ya
 * usa el carrito (`Checkout.js`) y el detalle de venta (`CompraDetail.js`), asi el
 * patron es uno solo en todo el sitio.
 */
const ItemsCards = ({items, mostrarCantidad}) => (
    <div className="venta-dp__items">
        {items?.map((item) => (
            <div className="checkout__product-item box-shadow-1" key={item.id}>
                <div className="checkout__product-item-infoWrapper">
                    <div className="checkout__product-item-info">
                        <div className="checkout__product-header">
                            <div className="checkout__product-title">
                                <h4>{item.tipoRepuesto?.nombre}</h4>
                            </div>
                            <div className="checkout__product-price">
                                <NumberFormat
                                    prefix={'$'}
                                    value={item.precioUnitario}
                                    displayType={'text'}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                />
                            </div>
                        </div>
                        <div className="checkout__product-body">
                            {mostrarCantidad && item.cantidad && (
                                <p>Cantidad: <span>{item.cantidad}</span></p>
                            )}
                            <p>Marca: <span>{item.marca?.nombre}</span></p>
                            <p>Modelo: <span>{item.modelo?.nombre}</span></p>
                            {item.version?.nombre && (
                                <p>Versión: <span>{item.version?.nombre}</span></p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        ))}
    </div>
);

const DireccionEnvio = ({rowData}) => (
    <div className="seller-data">
        <div>Dirección: <span>{rowData.direccion}</span></div>
        <div>Código Postal: <span>{rowData.codigoPostal}</span></div>
        <div>Ciudad: <span>{rowData.ciudad}</span></div>
        <div>Provincia: <span>{rowData.provincia}</span></div>
    </div>
);

export const VentaDP = ({rowData}) => (
    <Container fluid className="candado-container">
        <Row className="bg-silver p-3">
            <Col sm={12} className="mb-3">
                <h5>Productos</h5>
                <ItemsCards items={rowData.items}/>
            </Col>
            {rowData.tipoEnvio === TIPO_ENVIO.ENVIO_A_COORDINAR &&
            <Col sm={12} className="mb-3">
                <h5>Dirección de envio</h5>
                <DireccionEnvio rowData={rowData}/>
            </Col>}
        </Row>
    </Container>
);

export const CompraDP = ({rowData}) => (
    <Container fluid className="candado-container">
        <Row className="bg-silver p-3">
            <Col sm={12} className="mb-3">
                <h5>Productos</h5>
                <ItemsCards items={rowData.items} mostrarCantidad/>
            </Col>

            {rowData.tipoEnvio == TIPO_ENVIO.ENVIO_A_COORDINAR &&
            <Col sm={12} className="mb-3">
                <h5>Dirección de envio</h5>
                <DireccionEnvio rowData={rowData}/>
            </Col>}
        </Row>
    </Container>
);
